import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getYardAvailableColumns } from './api';

export const path = '/yard/list';

const PageYardList: React.FC = (props) => {
  const YardList = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getYardAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <YardList {...props} />;
};

export default PageYardList;
